export { TextInput, type TextInputProps } from "./text-input";
export { TextInput as default } from "./text-input";
